/**
 * Cutton = "C"lueso + B"utton"
 * (A button for Clueso)
 */

import React, { useState } from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import "./Cutton.css";
import downArrowheadIcon from "../../../assets/svgs/downArrowheadIcon";
import { Size } from "../../../types/sizes";

export type CuttonProps = {
	children?: React.ReactNode | string;
	onClick?: (e: React.MouseEvent) => void;
	className?: string;
	url?: string;
	urlTarget?: string;
	rank?: "primary" | "secondary" | "tertiary" | "quaternary";
	theme?: "danger" | "pink" | "blue";
	isLoading?: boolean;
	rightIcon?: React.ReactElement;
	leftIcon?: React.ReactElement;
	magicShadow?: boolean;
	rightArrow?: boolean;
	loadingText?: string;
	disabled?: boolean;
	size?: Size;
	betaLabel?: boolean;
	fullWidth?: boolean;
	type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
};

const Cutton: React.FC<CuttonProps> = ({ children, ...props }) => {
	const rank = props.rank || "primary";

	const disabled = props.isLoading || props.disabled;

	const content = (
		<>
			{children}
			{props.betaLabel ? (
				<div className="Cutton-beta-label">BETA</div>
			) : null}

			<div className="Cutton-right-icon-container">
				{props.rightArrow ? downArrowheadIcon("white") : null}
			</div>
		</>
	);

	const cutton = (
		<Button
			onClick={disabled ? undefined : props.onClick}
			color={"white"}
			className={`Cutton-Button ${rank}  ${props.theme}
                    ${props.magicShadow ? "magicShadow" : ""}
                    ${props.rightArrow ? "Cutton-rightArrow" : ""}
                    ${props.isLoading ? "Cutton-loading" : "Cutton-notloading"}
                    ${props.fullWidth ? "Cutton-fullWidth" : ""} 
		    ${props.className}
                `}
			leftIcon={props.leftIcon}
			rightIcon={props.rightIcon}
			isLoading={props.isLoading}
			loadingText={props.loadingText}
			isDisabled={disabled}
			type={props.type ?? "button"}
		>
			<div
				className={`${props.className}`}
				style={{
					display: "inline-flex",
					alignItems: "center",
				}}
			>
				{content}
			</div>
		</Button>
	);

	if (props.url) {
		return (
			<a
				href={props.url}
				target={props.urlTarget ?? "_blank"}
				rel="noopener noreferrer"
				className={`Cutton ${props.size} ${props.fullWidth}`}
			>
				{cutton}
			</a>
		);
	}
	return (
		<div
			className={`Cutton ${props.size ?? "r"} ${props.fullWidth ? "fullWidth" : ""}`}
		>
			{cutton}
		</div>
	);
};

export default Cutton;
